module.exports = __webpack_public_path__ + "img/f3.047bcb72.png";